import { useEffect, useState } from "react";
import axios from "axios";
import { TbDots, TbEdit, TbTrash, TbUsers, TbAlertCircle, TbCheck } from "react-icons/tb";

export default function RoomsCard({ room, openRoom, deleteRoom }) {
  const [hasAvailability, setHasAvailability] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  // Vérifier si la room a une availability configurée
  useEffect(() => {
    const checkAvailability = async () => {
      try {
        const today = new Date().toISOString().split("T")[0];
        const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];

        const res = await axios.get(
          `https://api.komorotel.com/api/availability/${room._id}?startDate=${today}&endDate=${tomorrow}`,
          { withCredentials: true }
        );

        setHasAvailability(res.data.length > 0);
      } catch {
        setHasAvailability(false);
      }
    };

    checkAvailability();
  }, [room._id]);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm hover:-translate-y-1 transition-all duration-200 hover:shadow-md">

      {/* IMAGE */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={room.photos?.[0] || "/placeholder.jpg"}
          className="w-full h-full object-cover"
        />

        {/* Badge availability */}
        <div className="absolute top-3 left-3">
          {hasAvailability === null ? null : hasAvailability ? (
            <span className="flex items-center gap-1 px-2.5 py-1 bg-green-500 text-white text-xs font-medium rounded-full">
              <TbCheck className="text-xs" /> Configurée
            </span>
          ) : (
            <span className="flex items-center gap-1 px-2.5 py-1 bg-orange-500 text-white text-xs font-medium rounded-full">
              <TbAlertCircle className="text-xs" /> Availability manquante
            </span>
          )}
        </div>

        {/* Menu */}
        <div className="absolute top-3 right-3">
          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm hover:bg-gray-50 transition"
            >
              <TbDots className="text-gray-600" />
            </button>

            {menuOpen && (
              <>
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setMenuOpen(false)}
                />
                <div className="absolute right-0 top-9 z-20 bg-white rounded-xl shadow-lg border border-gray-100 py-1 w-40">
                  <button
                    onClick={() => { openRoom(room); setMenuOpen(false); }}
                    className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition"
                  >
                    <TbEdit className="text-gray-400" /> Modifier
                  </button>
                  <button
                    onClick={() => { deleteRoom(room._id); setMenuOpen(false); }}
                    className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-500 hover:bg-red-50 transition"
                  >
                    <TbTrash /> Supprimer
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="p-4">

        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-semibold text-gray-900">{room.title}</h3>
            <div className="flex items-center gap-1 text-xs text-gray-400 mt-1">
              <TbUsers />
              <span>{room.maxPeople} personnes max</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="flex gap-2 mt-4">
          <button
            onClick={() => openRoom(room)}
            className="flex-1 py-2 rounded-xl text-sm font-medium border border-gray-200 text-gray-700 hover:bg-gray-50 transition"
          >
            Modifier
          </button>

          {!hasAvailability && (
            <button
              onClick={() => openRoom(room, "availability")}
              className="flex-1 py-2 rounded-xl text-sm font-medium bg-orange-500 text-white hover:bg-orange-600 transition"
            >
              Configurer
            </button>
          )}
        </div>

      </div>

    </div>
  );
}
